import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/projections")({
  component: ProjectionsRoute,
});

function ProjectionsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <PlaneRoutePage kindId="projections" search={search} />;
}
